import gql from "graphql-tag";
import { AlertFragment } from "./fragments";
import { Alert } from "types";
import { createBoundMutation } from "./util";

const upsertMutation = gql`
  mutation upsertAlert(
    $id: String
    $memo_id: String
    $alert_template_id: String
    $name: String
    $start_date: String
    $end_date: String
    $first_alert_time: String
    $second_alert_time: String
    $phones: [String]
    $emails: [String]
  ) {
    upsertAlert(
      id: $id
      memo_id: $memo_id
      alert_template_id: $alert_template_id
      name: $name
      start_date: $start_date
      end_date: $end_date
      first_alert_time: $first_alert_time
      second_alert_time: $second_alert_time
      phones: $phones
      emails: $emails
    ) {
      ...AlertFragment
    }
  }
  ${AlertFragment}
`;
const deleteMutation = gql`
  mutation deleteAlert($id: String!) {
    deleteAlert(id: $id)
  }
`;

export namespace alertMutations {
  export interface UpsertAlertArgs {
    id?: string | null;
    name?: string;
    memo_id: string;
    alert_template_id?: string | null;
    start_date: string;
    end_date: string;
    first_alert_time: string;
    second_alert_time: string;
    phones: string[];
    emails: string[];
  }

  export interface UpsertAlertData {
    upsertAlert: Alert;
  }
  export const UpsertAlert = createBoundMutation<
    UpsertAlertData,
    UpsertAlertArgs
  >({
    mutation: upsertMutation,
    cacheKey: "alerts",
    isAdd: true
  });

  export interface DeleteAlertData {
    deleteAlert: string;
  }
  export interface DeleteAlertArgs {
    id: string;
  }

  export const DeleteAlert = createBoundMutation<
    DeleteAlertData,
    DeleteAlertArgs
  >({
    mutation: deleteMutation,
    cacheKey: "alerts",
    isDelete: true
  });
}



// WEBPACK FOOTER //
// ./src/api/alert.ts